export default __webpack_public_path__ + "img/33d15c4638017e96875e55b7a33034ce.svg";